import { conversionCopy } from "@/lib/conversionCopy";
import founderImg from "../assets/founder.jpg";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { useLanguage } from "@/lib/useLanguage";

const AboutSection = () => {
  const { t: originalT, language } = useLanguage();
  const overrides: Record<string, string> = conversionCopy[language].homeText;
  const t = (key: string) => overrides[key] ?? originalT(key);

  return (
    <section className="bg-secondary py-8 lg:py-12">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid md:grid-cols-5 gap-12 lg:gap-16 items-center">
          {/* Left - 60% */}
          <div className="md:col-span-3">
            <h2 className="text-3xl md:text-[40px] font-bold text-primary mb-6 leading-tight">{t("about.heading")}</h2>
            <p className="text-muted-foreground leading-relaxed mb-8">{t("about.body")}</p>
            <ul className="space-y-4 mb-8">
              <li className="flex items-start gap-3">
                <span className="text-xl flex-shrink-0">🇹🇭</span>
                <span className="text-sm text-foreground">{t("about.bullet1")}</span>
              </li>
              <li className="flex items-start gap-3">
                <span className="text-xl flex-shrink-0">🇳🇴</span>
                <span className="text-sm text-foreground">{t("about.bullet2")}</span>
              </li>
            </ul>
            <Link to="/about">
              <Button
                className="rounded-full px-6 py-5 text-sm font-semibold border-primary text-primary hover:bg-primary/5"
                variant="outline"
              >
                {t("about.cta")}
              </Button>
            </Link>
          </div>

          {/* Right - Founder photo */}
          <div className="md:col-span-2 flex items-center justify-center">
            <img
              src={founderImg}
              alt="Grunnlegger av NordicThai Translate"
              className="w-full max-w-xs rounded-2xl shadow-2xl object-cover object-top border-4 border-[#0f1c3d]"
              style={{ aspectRatio: "1 / 1" }}
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutSection;
